import { jsx as _jsx } from "react/jsx-runtime";
import { MessageAttachment } from './MessageAttachment';
const MessageAttachments = ({ attachments }) => {
    if (!attachments?.length)
        return null;
    return (_jsx("div", { className: "flex flex-col gap-2 mt-2", children: attachments.map((attachment, index) => (_jsx(MessageAttachment, { attachment: attachment }, `${attachment.link}-${index}`))) }));
};
export { MessageAttachments };
